import { compose } from 'recompose';
import { connect } from 'react-redux';
import { pipelineData } from 'reducers/modelPipeline/selectors';
import { mini } from 'reducers/dashboard/selectors';
import { addProps } from 'utils/recompose';
import combineSelectors from 'utils/combineSelectors';
import formatPipelineKeys from 'utils/formatPipelineKeys';

const mapStateToProps = combineSelectors({
  pipelineData,
  mini,
});

const pipelineSummary = ({ pipelineData }) =>
  (pipelineData &&
    pipelineData
      .sort(function(a, b) {
        return a.code - b.code;
      })
      .map(({ description, total }) => ({
        description: formatPipelineKeys(description),
        total,
      }))) ||
  [];

export default compose(
  connect(mapStateToProps),
  addProps({ pipelineSummary }),
);
